import Main from '@/views/administracion/adjudicaciones/Main.vue';
import Default from '@/views/administracion/adjudicaciones/Default.vue';
import MainAdjudicacion from '@/views/administracion/adjudicaciones/adjudicacion/Main.vue';
import DefaultAdjudicacion from '@/views/administracion/adjudicaciones/adjudicacion/Default.vue';

const auth = ['Adjudicaciones:ver'];
const scopes = ['Adjudicaciones:crear', 'Adjudicaciones:editar', 'Adjudicaciones:eliminar'];

const adjudicaciones = [
  {
    path: 'adjudicaciones',
    meta: {
      title: '',
      auth,
    },
    component: Main,
    children: [
      {
        name: 'adjudicaciones',
        path: '/',
        meta: {
          title: 'Adjudicaciones',
          auth,
          scopes,
        },
        component: Default,

        children: [],
      },
      {
        path: ':idAdjudicacion',
        meta: {
          title: 'Adjudicacion',
          auth,
          scopes,
        },
        component: MainAdjudicacion,
        children: [
          {
            name: 'adjudicacion',
            path: '/',
            meta: {
              title: 'Adjudicacion',
              auth,
              scopes,
            },
            component: DefaultAdjudicacion,
          },
        ],
      },
    ],
  },
];

export default adjudicaciones;
